module.exports = __webpack_public_path__ + "static/media/line-chart-24px.91c8887a.svg";